import React, { useState } from 'react';
import { Route, NavLink, Link, BrowserRouter as Router, Switch } from 'react-router-dom'
import IClose from '../img/icon_close.svg';
import IMenu from '../img/icon_menu.svg';

function Navbar() {
  const [showMenu, setShowMenu] = useState(false);
  const onClick = () => setShowMenu(!showMenu)

  const Results = () => (
    <div className={"font-semibold text-blue-600 mt-2"}>
      <NavLink exact to="/" className={"navbar-mobile-def mb-1"} activeClassName={"navbar-mobile-active mb-1"} activeStyle={{color:'white'}} onClick={onClick}>Home</NavLink>
      <NavLink exact to="/projects" className={"navbar-mobile-def mb-1"} activeClassName={"navbar-mobile-active mb-1"} activeStyle={{color:'white'}} onClick={onClick}>Projects</NavLink>
      <NavLink exact to="/skills" className={"navbar-mobile-def mb-1"} activeClassName={"navbar-mobile-active mb-1"} activeStyle={{color:'white'}} onClick={onClick}>Skills</NavLink>
      <NavLink exact to="/work_histories" className={"navbar-mobile-def"} activeClassName={"navbar-mobile-active"} activeStyle={{color:'white'}} onClick={onClick}>Work Histories</NavLink>
    </div>
  )

  return (
    <div className="bg-white py-2 shadow-md fixed w-full">

      <div className={"flex items-center px-4 md:px-0 max-w-screen-md m-auto"}>
        <div className="flex-grow cursor-pointer">
          <span className="text-2xl sm:text-3xl text-blue-600 font-semibold">Jetwiz</span>
        </div>

        <button className="block md:hidden text-blue-600 focus:outline-none" onClick={onClick} >
          <img className={"fill-current"} src={showMenu ? IClose : IMenu } alt="button" />
        </button>

        <div className="hidden md:block">
          <ul className="inline-flex font-semibold">
            <li className="mr-6">
              <NavLink exact to="/" className={"navbar-web-def"} activeClassName={"navbar-web-active"} activeStyle={{color:'white'}}>Home</NavLink>
            </li>
            <li className="mr-6">
              <NavLink exact to="/projects" className={"navbar-web-def"} activeClassName={"navbar-web-active"} activeStyle={{color:'white'}}>Project</NavLink>
            </li>
            <li className="mr-6">
              <NavLink exact to="/skills" className={"navbar-web-def"} activeClassName={"navbar-web-active"} activeStyle={{color:'white'}}>Skills</NavLink>
            </li>
            <li className="">
              <NavLink exact to="/work_histories" className={"navbar-web-def"} activeClassName={"navbar-web-active"} activeStyle={{color:'white'}}>Work Histories</NavLink>
            </li>
          </ul>
        </div>
      </div>

      {showMenu ? <Results /> : null}
    </div>
  )
}

export default Navbar;